<ng-template #body>
    <div class="journey-panel-container item" *ngFor="let item of items; index as i"
        [style.background]="item?.persona?.color" (click)="onSelected(item, i)"
        [ngClass]="{'selected': item?.selected}">
        <div class="order state-icon" [ngClass]="{'green': [2, 3].includes(item?.statusColor), 'yellow': item?.statusColor === 1 }">
            <div>{{item.step_num}}</div>
        </div>
        <div>
            <div class="title text-truncate">{{item?.name}}</div>
            <div class="time">{{ item?.expected_date | dateUTC}}</div>
        </div>
        <!-- <div [ngClass]="{'green': item?.status,'white': !item?.status }" class="state-icon"></div> -->
    </div>
    @if(notification) {
        <div class="mt-3">
            <div class="mb-2">{{'Notification' | translate}}</div>
            <div class="mb-2 flex">
                <span class="noti-icon" [class.inactive]="!notification.enable" (click)="onClickNotification()"></span>
                <span>
                    <b>
                        {{(notification.enable ? 'You are receiving notification for this job' : 'You are not receiving notification for this job') | translate}}
                    </b>
                </span>
            </div>
        </div>
    }
    @if(categories.length) {
        <div class="mt-3">
            <div class="mb-1">{{'Category' | translate}}</div>
            <ng-select
                notFoundText="{{'No items found' | translate}}"
                placeholder="{{ 'Select Category' | translate }}"
                [items]="categories"
                bindLabel="name"
                bindValue="id"
                [hideSelected]="true"
                [clearable]="true"
                [searchable]="true"
                [multiple]="true"
                [readonly]="readOnly"
                [(ngModel)]="category_ids"
                (change)="onChangeCategory($event)"
            ></ng-select>
        </div>
    }
    <div class="mt-3" *ngIf="flowCancelReason">
        <div>{{'Status' | translate}}</div>
        <div class="mb-2"><b>{{'Rejected' | translate}}</b></div>
        <div>{{'Reason for Rejection' | translate}}</div>
        <div><b>{{flowCancelReason}}</b></div>
    </div>
</ng-template>

<ng-template #itemSelected>
    <div class="journey-panel-container item" [style.background]="configObj?.itemSelected?.persona?.color"
        [ngClass]="{'selected': configObj?.itemSelected?.selected}">
        <div class="order state-icon" [ngClass]="{'green': configObj?.itemSelected?.status_color === 2, 'yellow': configObj?.itemSelected?.status_color === 1 }">
            <div>{{configObj?.itemSelected?.step_num}}</div>
        </div>
        <div>
            <div class="title text-truncate">{{configObj?.itemSelected?.name}}</div>
            <div class="time">{{ configObj?.itemSelected?.expected_date | dateUTC}}</div>
        </div>
        <!-- <div [ngClass]="{'green': configObj?.itemSelected?.status,'white': !configObj?.itemSelected?.status }"
            class="state-icon"></div> -->
    </div>
</ng-template>
<app-panel-box [bodyTemplate]="body" [config]="configObj" [itemSelectedTemplate]="itemSelected"></app-panel-box>
